import api from './client';

export const logsAPI = {
  getAll: async (params?: {
    device_id?: number;
    limit?: number;
    offset?: number;
    action?: string;
    start_date?: string;
    end_date?: string;
    ip_address?: string;
    license_key?: string;
  }) => {
    const response = await api.get('/api/admin/logs', { params });
    return response.data;
  },

  getStats: async (params?: {
    device_id?: number;
    start_date?: string;
    end_date?: string;
  }) => {
    const response = await api.get('/api/admin/logs/stats', { params });
    return response.data;
  },

  export: async (params?: {
    device_id?: number;
    action?: string;
    start_date?: string;
    end_date?: string;
    ip_address?: string;
    license_key?: string;
  }) => {
    const response = await api.get('/api/admin/logs/export', {
      params,
      responseType: 'blob',
    });
    return response;
  },
};
